export const CHANGE_USER_STATUS_REQUEST = 'CHANGE_USER_STATUS_REQUEST';
export const CHANGE_USER_STATUS_SUCCESS = 'CHANGE_USER_STATUS_SUCCESS';
export const CHANGE_USER_STATUS_FAILURE = 'CHANGE_USER_STATUS_FAILURES';



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_list/redux/constants/change_user_status.constants.js